




















import Vue, { PropType } from "vue";

// Model
import { InstallationPredictedStatus } from "@/model/data/predictiveMaintenance/InstallationPredictedStatus";
import MachineLogAnalysisCharts from "./MachineLogAnalysisCharts.vue";

export default Vue.extend({
    props: {
        installation: Object as PropType<InstallationPredictedStatus>,
        startDate: {
            type: Date,
            default: null,
        },
        endDate: {
            type: Date,
            default: null,
        },
        hideDaysToogle: {
            type: Boolean,
            default: false,
        },
    },
    components: { MachineLogAnalysisCharts },
    computed: {
        availableMachines() {
            if (this.installation && this.installation.machines) return this.installation.machines.filter((m) => m.model != "DropVault");
            return [];
        },
    },
});
